import React from "react";
import { Container } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import "react-awesome-slider/dist/styles.css";
import blockchainTransactionViewImg from "../../images/block.png";
import appDrivenViewImg from "../../images/mobile-app.png";
import { NavLink } from "react-router-dom";
import { Typography } from "@material-ui/core";

// Main component for CoreStack
const CoreStackData = [
  {
    title: "Blockchain Stack",
    image: blockchainTransactionViewImg,
    path: "/blockchain-stack",
  },
  { 
    title: "Registry Stack", 
    image: appDrivenViewImg, 
    path: "/registry-stack" 
  },
   { 
    title: "Common Stack", 
    image: blockchainTransactionViewImg, 
    path: "/blockchain-stack" 
  },
];

const CoreStack = () => {
  return (
    // Main container for CoreStack
    <div maxwidth={12} className="businessPartnerContainer explore-app-background">
      
      {/* Grid Section Wrapper */}
      <Container maxWidth="sm" className="gridSection gridSection--mod">
        
        {/* Grid Layout for Core Stack Items */}
        <Grid
          container
          alignItems="center"
          spacing={1}
          direction="row"
          justifyContent="center"
        >
          {/* Mapping through CoreStackData to render items dynamically */}
          {CoreStackData.map(({ title, image, path }, index) => {
            return (
              <Grid 
                item 
                md={2} sm={4} xs={6} 
                key={index} 
                className="stack-data-container"
              >
                {/* Navigation to corresponding stack pages */}
                <NavLink to={path}>
                  <img src={image} alt={title} />
                  <Typography variant="h4" align="center">
                    {title}
                  </Typography>
                </NavLink>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </div>
  );
};

export default CoreStack;

